import React from "react";
import { Stack, Link, Typography, StackProps, useTheme } from "@mui/material";
import { To, Link as RouterLink, useNavigate } from "react-router";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import useSticky from "../../../Utils/Hooks/useSticky";

export interface SinglePageHeaderProps extends StackProps {
  children?: React.ReactNode;
  backButton?: {
    label: string;
    to: To;
    toPrevious?: boolean;
  };
  subtitle?: string;
  title: string;
  leftContent?: string;
  footerContent?: string;
}

const SinglePageHeader: React.FC<SinglePageHeaderProps> = (props) => {
  const { children, title, subtitle, backButton, footerContent, ...otherProps } = props;
  const navigate = useNavigate();
  const theme = useTheme();

  //const { ref, isSticky } = useSticky();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      //className={isSticky ? "sticky" : ""}
      spacing={4}
      //ref={ref}
      sx={{
        //backgroundColor: isSticky ? theme.palette.background.default : "transparent",
        //position: "sticky",
        //top: "-1px",
        //zIndex: 2,
        mb: 1,
        py: 2,
        // marginLeft: isSticky ? theme.spacing(-2) : 0,
        // marginRight: isSticky ? theme.spacing(-2) : 0,
        // paddingLeft: isSticky ? theme.spacing(2) : 0,
        // paddingRight: isSticky ? theme.spacing(2) : 0,
        // boxShadow: isSticky ? theme.helpers(theme).stickyHighlights.boxShadow : "none",
      }}
      {...otherProps}
    >
      <Stack>
        {subtitle && (
          <Typography variant="h6" component="h2" color="text.tier" pl={1} mb={0.5}>
            {subtitle}
          </Typography>
        )}
        <Typography variant="h3" sx={(theme) => ({ pl: 1, ...theme.helpers(theme).ellipsis })}>
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1} flexWrap="nowrap">
        {children}
      </Stack>
      {footerContent}
    </Stack>
  );
};

export default SinglePageHeader;

export type SinglePageHeaderGroupActionsProps = StackProps;
const SinglePageHeaderGroupActions: React.FC<SinglePageHeaderGroupActionsProps> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1} {...otherProps}>
      {children}
    </Stack>
  );
};

export { SinglePageHeaderGroupActions };
